import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './store';

import firebase from './lib/firebase';
import { firebaseConfig } from './config/firbaseConfig';
import { initHelpPortalAuth } from './lib/customAuth';

firebase.initializeApp(firebaseConfig);
initHelpPortalAuth();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
